export const reqString = process.env.REACT_APP_API_URL;
